export default "__VITE_ASSET__BIFtYYCP__"